// extracted by mini-css-extract-plugin
export var emoji = "splash-module--emoji--GpU8w";
export var fade = "splash-module--fade--Az9u0";
export var splash = "splash-module--splash--FxXvL";
export var text1 = "splash-module--text1--lpzj2";
export var text2 = "splash-module--text2--24XPp";